/* eslint-disable jsx-a11y/heading-has-content */
import React from 'react';
import { font, palette } from 'styled-theme';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { switchProp, ifProp, prop } from 'styled-tools';
import theme from '../../../theme';

const TextWrap = ({ palette, paletteIndex, variant, bold, align, fontType, shadow, ...props }) => {
  switch (variant) {
    case 'h1':
      return <h1 {...props} />
    case 'h2':
      return <h2 {...props} />
    case 'h3':
      return <h3 {...props} />
    default:
      return <span {...props} />
  }
};

const StyledDiv = styled(TextWrap)`
  font-family: ${({ fontType }) => fontType ? font(fontType) : css`${font('primary')}, ${font('secondary')}`};
  color: ${({ palette, paletteIndex }) => theme.palette[palette][paletteIndex]};
  font-size: ${switchProp('variant', {
    h1: 'min(11vw, 4.4rem)',
    h2: 'min(8vw, 3rem)',
    h3: 'min(6vw, 2.2rem)',
    body1: 'min(4.3vw, 1.5rem)',
    body2: 'min(3vw, 1rem)',
    body3: 'min(2.6vw, 0.8rem)',
  })};
  line-height: 1.2;
  text-align: ${prop('align')};
  font-weight: ${ifProp('bold', 'bold', 'normal')};
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;
  ${ifProp('shadow', css`
    text-shadow: 1px 1px ${palette('grayscale', 1)};
  `)}
`;

const Text = ({ children, ...props }) => {
  return (
    <StyledDiv
      {...props}
    >
      {children}
    </StyledDiv>
  )
};

Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  palette: PropTypes.string,
  paletteIndex: PropTypes.number,
  variant: PropTypes.string,
  fontType: PropTypes.string,
  bold: PropTypes.bool,
  align: PropTypes.string,
  shadow: PropTypes.bool,
};

Text.defaultProps = {
  children: null,
  palette: 'white',
  paletteIndex: 0,
  variant: 'body1',
  bold: false,
  shadow: false,
};

export default Text;
